import React from 'react';

export const IconMan = () => (
    <svg width='24' height='24' xmlns='http://www.w3.org/2000/svg'>
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M4 18a10 10 0 1116 0c-.06-2.66-5.35-4-8-4-2.65 0-7.94 1.34-8 4zm-4-6a12 12 0 1124 0 12 12 0 01-24 0zm12-7c-.94 0-1.85.38-2.51 1.05a3.62 3.62 0 000 5.1 3.53 3.53 0 005.02 0 3.62 3.62 0 000-5.1A3.53 3.53 0 0012 5z'
            fill='currentColor'
        />
    </svg>
);
